import { connect } from 'react-redux';
import Dashboard from './dashboard'
import * as AC from '../../../actions/actionCreators'

function mapStateToProps(state) { 
	return {
        isLoading: state.panel.isLoading || state.request.isLoading || state.panelChange.isLoading || state.user.isLoading || state.panelChange.isSaving || state.request.isSaving,
        errorRequest: state.request.error,
        errorPanelChange: state.panelChange.error,
        errorPanel: state.panel.error,
        errorUser: state.user.error,
        profile: state.profile,
        users: [
            { key: '-', value: '-', text: 'Mindenki'},
            ...state.user.users
                .filter((u) => (u.role || '').toUpperCase() === 'VISITOR')
                .map((u) => ({ value: u.visitorTerritory, key: u.id, text: u.name + ' (' + u.visitorTerritory + ')' }))
        ],
        actualPanel: state.panel.actualPanel,
        allPanels: state.panel.allActualPanel,
        requests: state.request.requests,
        allRequests: state.request.allRequests,
        panelChanges: state.panelChange.panelChanges,
        allPanelChanges: state.panelChange.allPanelChanges
}};

function mapDispatchToProps(dispatch) {
    return({
        resetAll: () => { dispatch(AC.ResetAll()) },
        fetchUsers: (rsm) => { dispatch(AC.UserListLoadingStarted(rsm) ) },
        fetchRequests: (visitorTerritory) => { dispatch(AC.RequestsLoadingStarted(visitorTerritory) ) },
        fetchPanelChanges: (visitorTerritory, detailed) => { dispatch(AC.PanelChangesLoadingStarted(visitorTerritory, detailed) ) },
        fetchPanel: (visitorTerritory, detailed) => { dispatch(AC.PanelLoadingStarted(visitorTerritory, detailed) ) },
        fetchAllPanel: (rsm) => { dispatch(AC.PanelAllLoadingStarted(rsm) ) },
        fetchAllRequests: (rsm) => { dispatch(AC.RequestsAllLoadingStarted(rsm) ) },
        fetchAllPanelChanges: (rsm) => { dispatch(AC.PanelChangesAllLoadingStarted(rsm) ) },        
    })
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);